<template>
    <section  class="confirm-my-car" id="confirmMyCar">
        <div class="confirm-my-car__container container">
            <h1 class="valuation-layout__header">Free Instant Vehicle Valuation</h1>
            <StepBar />
            <StepLink :step="step - 1" />
            <ManualValuationForm v-if="displayManualDetailsForm" ></ManualValuationForm>
            <div v-else class="rd-card rd-card--border-top  confirm-my-car__card">
                <div class="card__inner confirm-my-car__card-inner">
                    <div class="confirm-my-car__car-details">
                        <h3 class="confirm-my-car__title">Your Vehicle Details</h3>
                        <div>
                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Make:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.make }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Model:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.model }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Bodystyle:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.body_type }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Derivative:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.derivative }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Engine size:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.engine_size }} cc</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Fuel type:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.fuel_type }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Transmission:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.transmission }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Registration date:</span>
                                <span class="confirm-my-car__value">{{ selectedVehicle.first_registered }}</span>
                            </div>

                            <div class="confirm-my-car__row">
                                <span class="confirm-my-car__label">Mileage entered:</span>
                                <span class="confirm-my-car__value">{{ mileage }}</span>
                            </div>
                        </div>
                        <loading-spinner v-if="loading" />
                        <button type="button" class="btn btn--primary card__button confirm-my-car__button" @click.prevent="submitConfirmVehicle">
                            <span>Continue</span>
                        </button>
                        <div class="confirm-my-car__button-area-mobile ">
                            <button type="button" class="btn btn--primary card__button confirm-my-car__button-mobile" @click.prevent="submitConfirmVehicle">
                                <span>Continue</span>
                            </button>
                            <a class="link link--is-button link--secondary link--has-icon confirm-my-car__link confirm-my-car__link--mobile" @click.prevent="showCarForm()">This is not my car</a>
                        </div>
                    </div>
                    <div class="confirm-my-car__car-image-container">
                        <img v-if="selectedVehicle" class="confirm-my-car__car-image" :class="{ 'confirm-my-car__not-found-image': otherSelected, 'confirm-my-car__car-image-desktop--imagin-studio': imaginStudioImage }" :src="vehicleImage" alt="Car Image" />
                        <p class="confirm-my-car__illustrative-message" :class="{'confirm-my-car__illustrative-message--imagin-studio': imaginStudioImage }" >Image for illustrative purposes only</p>
                        <div class="confirm-my-car__link-container confirm-my-car__button-area" :class="{'confirm-my-car__link--imagin-studio': imaginStudioImage }">
                            <a class="link link--is-button link--secondary link--has-icon confirm-my-car__link"  @click.prevent="showCarForm()">This is not my car</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex/dist/vuex.esm.browser";
import { LoadingSpinner, StepBar, StepLink, ManualValuationForm, QrCode} from "../";


export default {
    components: {
        LoadingSpinner,
        StepBar,
        StepLink,
        ManualValuationForm,
        QrCode,
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        ...mapState("ValuationTool", ["selectedVehicle", "otherSelected", "step", "mileage", "hasUkVehicleData"]),
        ...mapGetters("ValuationTool", ["vehicleImage"]),

        imaginStudioImage() {
            return String(this.vehicleImage).substring(0, 25) == 'https://cdn.imagin.studio';
        },

        displayManualDetailsForm() {
            if (this.hasUkVehicleData === false || this.otherSelected) {
                return true;
            }
            return false;
        }
    },

    methods: {
        ...mapMutations("ValuationTool", ["setOtherSelected", "setNotMyVehicle"]),
        ...mapActions("ValuationTool", ["confirmVehicle", "goToPosition"]),

        submitConfirmVehicle() {
            if (this.loading) {
                console.warn("Vehicle confirmation is already in progress.");
                return;
            }

            this.loading = true;
            this.confirmVehicle()
                .then(() => {
                    this.loading = false;
                })
                .catch(error => {
                    console.error("Error confirming vehicle:", error);
                    this.loading = false;
                });
        },

        showCarForm() {
            this.setNotMyVehicle(true);
            this.setOtherSelected(true);
        },
    },
    mounted() {
        this.goToPosition('valuation-start')
    }
};
</script>